<template>
  <header class="sfdocs__header folder-icon">
    <div class="sfdocs__root-folder">
      <h3 class="sfdocs__root-path align-text-vertically">{{ info }}</h3>
    </div>
    <nav class="sfdocs__nav">
      <ul>
        <li v-if="currentDirectory !== '/'">
          <button @click="back">Back</button>
        </li>
        <li v-if="currentDirectory !== '/'">
          <button @click="fireUpload">
            Upload
          </button>
          <input
            ref="fileInput"
            type="file"
            style="display: none;"
            @change="filesSelected"
            multiple
          />
        </li>
        <li>
          <router-link 
            tag='button'
            :to="relatedFilesLink">Related Files
          </router-link>
        </li>
        <li><button @click="help">Help</button></li>
        <li><button @click="logout">Logout</button></li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import AWS from 'aws-sdk';

export default {
  name: 'PageHeader',
  data() {
    return {
      sns: null
    };
  },
  computed: {
    ...mapState(['currentDirectory', 'loggedIn']),
    domain() {
      return `${this.$route.params.recordType}/${
        this.$route.params.recordTypeSalesforceId
      }${this.currentDirectory}`;
    },
    info() {
      return this.$route.query.info;
    },
    lastDirectory() {
      const lastSlash = this.currentDirectory.lastIndexOf('/');
      if (lastSlash === 0) {
        return '/';
      } else {
        return this.currentDirectory.slice(
          0,
          this.currentDirectory.lastIndexOf('/')
        );
      }
    },
    relatedFilesLink() {
      return `/related/${this.$route.params.orgSalesforceId}/${this.$route.params.recordType}/${this.$route.params.recordTypeSalesforceId}?info=${this.$route.query.info}`;
    }
  },
  methods: {
    ...mapMutations(['SET_CURRENT_DIRECTORY']),
    back() {
      this.SET_CURRENT_DIRECTORY({
        currentDirectory: this.lastDirectory
      });
    },
    fireUpload() {
      this.$refs['fileInput'].value = null;
      this.$refs['fileInput'].click();
    },
    filesSelected() {
      const files = this.$refs['fileInput'].files;
      if (files && files.length > 0) {
        this.$emit('files-added', this.$refs['fileInput'].files);
      }
    },
    logout() {
      this.$router.push({
        name: 'logout'
      });
    },
    async help() {
      try {
        const creds = await this.$Amplify.Auth.currentSession();

        let message = `User with email ${
          creds.idToken.payload.email
        } has requested help.\n Help requested on page: ${
          window.location.href
        }.`;

        // if they are on 'folder-view' route, add current folder information, as it may help with debugging
        if (this.$route.name === 'folder-view') {
          message = `${message} In folder: ${this.currentDirectory}.`;
        }

        const publish = () =>
          new Promise((resolve, reject) => {
            this.sns.publish(
              {
                Message: message,
                Subject: 'Help Request',
                TopicArn: process.env.VUE_APP_SNS_TOPIC_ARN
              },
              (err, data) => {
                if (err) {
                  return reject(err);
                }
                resolve(data);
              }
            );
          });
        await publish();
        alert('Your request for assistance has been submitted.');
      } catch (e) {
        console.log('Failed to publish SNS notification', e);
      }
    }
  },
  async mounted() {
    try {
      const credentials = await this.$Amplify.Auth.currentCredentials();

      // create SNS object
      this.sns = new AWS.SNS({
        credentials: this.$Amplify.Auth.essentialCredentials(credentials)
      });
    } catch (e) {
      console.log(e);
    }
  }
};
</script>
